import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { TopicRow } from '../topics-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<TopicRow, unknown>[] = [
		buildColumn(util, 'Id', row => row.accTopicId, { header: 'accTopicId' }),
		buildColumn(util, 'Id', row => row.topicId, { header: 'topicId' }),
		buildColumn(util, 'Id', row => row.accSessionId, { header: 'accSessionId' }),
		buildColumn(util, 'Text', row => row.topicName, { header: 'Topic' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.sessionStartUTC), { header: 'Session' }),
		buildColumn(util, 'Text', row => row.specialistNames, { header: 'Specialists' }),
		buildColumn(util, 'Number', row => row.materialsCount, { header: "# Materials", headerTooltip: 'Count of Materials', hidden: true }),
		buildColumn(util, 'Number', row => row.topicSurveyResults, { header: '# Surveys', headerTooltip: 'Topic Surveys Taken' }),
		buildColumn(util, 'Number', row => row.topicSurveyRelevanceScore, { header: 'Relevance Score', headerTooltip: 'Relevance Score [0-100] Asked: "This topic is important for my business"', hidden: true }),
		buildColumn(util, 'Number', row => row.topicSurveyNeedScore, { header: 'Need Score', headerTooltip: 'Need Score [0-100] Asked: "I will use this topic knowledge within the next three months"', hidden: true }),
		buildColumn(util, 'Number', row => row.topicSurveyUnderstandingScore, { header: 'Understanding Score', headerTooltip: 'Understanding Score [0-100] Asked: "I have a better understanding of this topic and can more confidently apply it"', hidden: true }),
		buildColumn(util, 'Number', row => row.topicSurveyDurationScore, { header: 'Duration Score', headerTooltip: 'Duration Score [0-100] Asked: "There was adequate time dedicated to this topic"', hidden: true }),
	];


	return columns;

}